import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import Button, { ButtonType } from '../Button/Button';
import { ErrorFallbackProps } from './ErrorBoundary';

const ErrorFallbackWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ErrorContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  max-width: 600px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const ErrorIcon = styled.div`
  font-size: 32px;
  margin-bottom: 24px;
`;

const ErrorTitle = styled.h1`
  color: #873139;
  font-size: 28px;
  margin-bottom: 16px;
  font-weight: 600;
`;

const ErrorDescription = styled.p`
  color: #6c757d;
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 32px;
`;

const ContactInfo = styled.p`
  color: #6c757d;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 32px;

  a {
    color: #007bff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 24px;
`;

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ resetError }) => {
  const handleRetry = () => {
    resetError();
  };

  const handleReload = () => {
    try {
      window.location.reload();
    } catch {
      // Firefox throws SecurityError when reloading from a sandboxed context
    }
  };

  return (
    <ErrorFallbackWrapper>
      <ErrorContainer>
        <ErrorIcon>ℹ️</ErrorIcon>
        <ErrorTitle>
          <FormattedMessage id="error.title" />
        </ErrorTitle>
        <ErrorDescription>
          <FormattedMessage id="error.description" />
        </ErrorDescription>
        <ContactInfo>
          <FormattedMessage id="error.contactInfo" />{' '}
          <a href="mailto:ritabygglov@gmail.com">ritabygglov@gmail.com</a>
        </ContactInfo>

        <ActionButtons>
          <Button onClick={handleReload} type={ButtonType.Primary}>
            <FormattedMessage id="error.reloadButton" />
          </Button>
          <Button onClick={handleRetry} type={ButtonType.PrimaryTertiary}>
            <FormattedMessage id="error.retryButton" />
          </Button>
        </ActionButtons>
      </ErrorContainer>
    </ErrorFallbackWrapper>
  );
};

export default ErrorFallback;
